import { Component, OnInit } from '@angular/core';
import { PartCategory } from '../../opc-app/partcategory/partcategory.model';
import { NotificationService } from '../../shared/services/notification.service';
import { OPCConstant } from '../../opc-app/opc.const';
import { Message } from 'primeng/api';
import { NgxSpinnerService } from 'ngx-spinner';
import { PartCategoryService } from '../../shared/services/partcategory.service';

@Component({
    selector: 'app-partcategory',
    templateUrl: './partcategory.component.html'
})
export class PartCategoryComponent implements OnInit {
    partCategories: PartCategory[];
    added: boolean;
    newPartCategory: PartCategory;
    notifications: Message[] = [];
    loading = false;
    pagedItems: any;
    startIndex: number;
    endIndex: number;

    constructor(private _partCategoryService: PartCategoryService,
        private notifyService: NotificationService, private spinner: NgxSpinnerService) { }

  ngOnInit(): void {
        this.loading = true;
        this.spinner.show();
        this.getAllPartCategories();
    }

    getAllPartCategories() {
        this._partCategoryService.getAllPartCategories().subscribe(res => {
          this.partCategories = res;

          this.partCategories.forEach(e => {            
            e['ListOfIndexOrderIds'] = this.partCategories.map(e => e.indexOrderID).sort((a, b) => {
              return a - b;
           });
          })
            this.spinner.hide();
            this.loading = false;
        });

      

    }
    setPageData(data: any) {
        this.pagedItems = this.partCategories.slice(data.startIndex, data.endIndex);
        this.startIndex = data.startIndex;
        this.endIndex = data.endIndex;
    }
    onSubmit(event) {
      if (event) {
            this.added = false;
            this.newPartCategory = new PartCategory();
            const pc = this.partCategories.find(p => p.partCategoryID === event.partCategoryID);
            if (pc) {
                const index = this.partCategories.indexOf(pc);
                this.partCategories[index] = event;
                this.notifications = this.notifyService.growlNotification('succ', OPCConstant.UPDATE_SUCCESS);
            } else {
                this.partCategories.unshift(event);
                this.notifications = this.notifyService.growlNotification('succ', OPCConstant.ADDED_SUCCESS);
        }
        this.getAllPartCategories();
        this.pagedItems = this.partCategories.slice(this.startIndex, this.endIndex);
        this.ngOnInit();

        //window.location.reload();

        }
    }
    onDelete(event, item) {
        if (event && item) {
            const index = this.partCategories.indexOf(item);
            this.partCategories.splice(+index, 1);
          this.notifications = this.notifyService.growlNotification('succ', OPCConstant.DELETE_SUCCESS);
          this.ngOnInit();
        } else {
            this.added = false;
      }
      this.ngOnInit();
    }
    onAddNew() {
        this.added = true;
      this.newPartCategory = new PartCategory();
      this._partCategoryService.addIndex = false;
    }
}



// WEBPACK FOOTER //
// ./src/opc/opc-admin/partcategory/partcategory.component.ts